/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: block;
}

.container {
  display: flex;
  inline-size: 100%;
  flex-wrap: nowrap;
  align-items: center;
}

.hex-input {
  flex-grow: 1;
  text-transform: uppercase;
}

.opacity-input {
  inline-size: 68px;
  margin-inline-start: -1px;
}

:host([scale=s]) .container {
  flex-wrap: wrap;
  row-gap: 0.125rem;
}
:host([scale=s]) .opacity-input {
  inline-size: unset;
  margin-inline-start: unset;
}

:host([scale=l]) .opacity-input {
  inline-size: 88px;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}